import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'credit-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'credit-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'credit-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'credit-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'credit-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'credit-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'credit-overview__menu--activity',
    informations: 'credit-overview__menu--general-info',
    financialactivity: 'credit-overview__menu--financial-info',
    contacts: 'credit-overview__menu--contact-linked',
    addresses: 'credit-overview__menu--address',
    customfields: 'credit-overview__menu--cf',
    statistics: 'credit-overview__menu--stat',
    opportunity: 'credit-overview__menu--opportunity',
    estimate: 'credit-overview__menu--document',
    invoice: 'credit-overview__menu--document',
    delivery: 'credit-overview__menu--document',
    order: 'credit-overview__menu--document',
    creditnote: 'credit-overview__menu--document',
    proforma: 'credit-overview__menu--document',
    payments: 'credit-overview__menu--payment',
    bankaccount: 'credit-overview__menu--bank-account',
    recurring: 'credit-overview__menu--recurring',
    mandates: 'credit-overview__menu--mandate',
    timetracking: 'credit-overview__menu--timetracking',
    tickets: 'credit-overview__menu--ticket',
    project: 'credit-overview__menu--project',
    proposal: 'credit-overview__menu--proposal',
    emailingprofile: 'credit-overview__menu--mailing-list',
    massmailingMailinglist: 'credit-overview__menu--mailing-list',
    massmailingCampaignList: 'credit-overview__menu--mailing-list',
    receipts: 'credit-overview__menu--receipt',
    briefcase: 'credit-overview__menu--briefcase',
    activitycommentadd: 'credit-overview__activity--comment-add',
    emailadd: 'credit-overview__activity--email-add',
    calladd: 'credit-overview__activity--call-add',
    taskadd: 'credit-overview__activity--task-add',
    eventadd: 'credit-overview__activity--event-add',
    generalinfoedit1: 'credit-overview__section--general-info-edit-1',
    generalinfoedit2: 'credit-overview__section--general-info-edit-2',
    marketing: 'credit-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
